module.exports = __webpack_public_path__ + "static/media/chevron__grey.b1fa752f.svg";